export const MODULE_NAME = 'integrations/connectif'

// Connectif Page Tags
export const CONNECTIF_PAGE_TAGS = {
  HOME: 'Pagina_Home',
  LANDING_SEO: 'Pagina_LandingSEO',
  DETAIL: 'Pagina_Ficha',
} as const

// Connectif Content Tags
export const CONNECTIF_CONTENT_TAGS = {
  HOME: 'Contenido_Home',
  TRANSACTIONAL: 'Contenido_Transaccional',
} as const
